export default __webpack_public_path__ + "static/media/facebook.2388f3d7.svg";